import { useQuery } from 'react-query';
import { fetchData } from './api';

const useFetchData = (queryKeys, endpoints) => {
  // Ensure queryKeys and endpoints are arrays
  const keys = Array.isArray(queryKeys) ? queryKeys : [queryKeys];
  const paths = Array.isArray(endpoints) ? endpoints : [endpoints];

  const fetchMultipleData = async () => {
    const responses = await Promise.all(paths.map(endpoint => fetchData(endpoint)));
    return keys.reduce((acc, key, index) => {
      acc[key] = responses[index];
      return acc;
    }, {});
  };

  return useQuery(keys.join('-'), fetchMultipleData);
};

export default useFetchData;
